import React from 'react'

const SidebarName = ({name}) => {
  return (
    <span className="align-middle">{name}</span>
  )
}

export default SidebarName